<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      label-width="100px"
      :selection="false"
    />
  </div>

</template>

<script>
import fieldFilter from '@/utils/fieldFilter.js'
export default {
  name: 'Hulianhutongmiyao',
  components: {},
  data() {
    return {
      url: '/setting/page',
      columns: [
        {
          label: '所属企业',
          prop: 'belongOrgName'
        },
        {
          label: '企业名称',
          prop: 'name'
        },
        {
          label: '企业类型',
          prop: 'orgType'
        }
      ],
      // 操作栏
      handles: {
        width: 260,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'valueadd.key.details',
            handle: resp => {
              this.$router.push({ path: './secretKeyDetail', query: { data: resp.id }})
            }
          },
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'valueadd.key.update',
            handle: resp => {
              this.$router.push({ path: './reviseSecretKey', query: { data: resp.id }})
            }
          }
        ]
      },
      query: [
        {
          label: '企业名称',
          prop: 'name',
          placeholder: '请输入企业名称'
        },
        {
          label: '企业类型',
          prop: 'orgType',
          placeholder: '请选择企业类型',
          type: 'select',
          data: [
            {
              label: '互联互通运营商',
              value: '0'
            },
            {
              label: '流量方',
              value: '1'
            },
            {
              label: '监管平台',
              value: '2'
            }
          ]
        },
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'valueadd.key.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addSecretKey')
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/systemManagement/secretKeymanagement.vue